export const scrollToTop = (behavior, element = window) => {
    try {
        element.scroll({top: 0, left: 0, behavior});
    } catch (error) {
        element.scrollTo(0, 0);
    }
};
